var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 1000,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2c46f8c7c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222 202 L 492.492188 202 L 492.492188 539.890625 L 222 539.890625 Z M 222 202 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8c60d85af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 426.359375 210.621094 C 404.6875 198.03125 374.707031 199.800781 341.570312 218.929688 C 275.777344 256.898438 222.640625 348.96875 222.835938 424.582031 C 222.898438 443.355469 226.21875 459.359375 232.238281 472.242188 C 233.753906 475.460938 235.394531 478.457031 237.230469 481.289062 C 240.871094 486.925781 245.152344 491.757812 249.984375 495.71875 C 252.398438 497.714844 254.941406 499.484375 257.617188 501.03125 L 323.632812 539.386719 C 302.25 526.953125 288.980469 500.515625 288.886719 462.96875 C 288.660156 387.386719 341.828125 295.285156 407.617188 257.316406 C 440.722656 238.1875 470.738281 236.414062 492.410156 249.007812 Z M 426.359375 210.621094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5c5c4e7bda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.480469 0 L 270.480469 0 L 270.480469 337.519531 L 0.480469 337.519531 Z M 0.480469 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8263fcea74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.359375 8.621094 C 182.6875 -3.96875 152.707031 -2.199219 119.570312 16.929688 C 53.777344 54.898438 0.640625 146.96875 0.835938 222.582031 C 0.898438 241.355469 4.21875 257.359375 10.238281 270.242188 C 11.753906 273.460938 13.394531 276.457031 15.230469 279.289062 C 18.871094 284.925781 23.152344 289.757812 27.984375 293.71875 C 30.398438 295.714844 32.941406 297.484375 35.617188 299.03125 L 101.632812 337.386719 C 80.25 324.953125 66.980469 298.515625 66.886719 260.96875 C 66.660156 185.386719 119.828125 93.285156 185.617188 55.316406 C 218.722656 36.1875 248.738281 34.414062 270.410156 47.007812 Z M 204.359375 8.621094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aca990eefb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 271,
    y: 0,
    height: 338
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "23dbcee4f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 214 193 L 502 193 L 502 548.1875 L 214 548.1875 Z M 214 193 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84ee02bbda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 394.996094 211.199219 C 380.148438 211.199219 363.402344 216.320312 345.886719 226.433594 C 282.636719 262.953125 231.304688 351.832031 231.5 424.546875 C 231.5625 441.648438 234.429688 456.460938 240.097656 468.539062 C 241.417969 471.371094 242.898438 474.042969 244.507812 476.523438 C 247.632812 481.355469 251.335938 485.542969 255.488281 488.988281 C 257.519531 490.660156 259.707031 492.175781 261.960938 493.496094 L 287.984375 508.632812 C 282.925781 495.554688 280.253906 480.195312 280.222656 462.96875 C 279.996094 384.710938 335.195312 289.101562 403.304688 249.78125 C 418.695312 240.890625 433.800781 235.351562 448.035156 233.195312 L 422.015625 218.09375 C 414.058594 213.488281 404.945312 211.167969 394.996094 211.167969 M 323.632812 548.046875 C 322.152344 548.046875 320.636719 547.660156 319.285156 546.890625 L 253.234375 508.503906 C 250.175781 506.730469 247.214844 504.671875 244.445312 502.382812 C 238.90625 497.84375 234.042969 492.304688 229.953125 485.992188 C 227.890625 482.835938 226.023438 479.421875 224.382812 475.878906 C 217.683594 461.484375 214.238281 444.222656 214.171875 424.613281 C 213.949219 346.359375 269.144531 250.746094 337.253906 211.425781 C 372.097656 191.300781 405.300781 188.335938 430.742188 203.117188 L 496.757812 241.472656 C 496.757812 241.472656 496.789062 241.472656 496.789062 241.503906 C 500.945312 243.917969 502.328125 249.199219 499.914062 253.355469 C 497.5 257.507812 492.183594 258.894531 488.0625 256.480469 C 468.257812 244.949219 441.207031 247.914062 411.964844 264.785156 C 348.6875 301.339844 297.355469 390.21875 297.546875 462.933594 C 297.644531 496.007812 308.433594 520.480469 327.914062 531.851562 L 327.980469 531.882812 C 332.132812 534.296875 333.519531 539.578125 331.105469 543.734375 C 329.492188 546.503906 326.59375 548.046875 323.601562 548.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72ee2fa542"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 288 0 L 288 355.160156 L 0 355.160156 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fae01e9be3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180.996094 18.199219 C 166.148438 18.199219 149.402344 23.320312 131.886719 33.433594 C 68.636719 69.953125 17.304688 158.832031 17.5 231.546875 C 17.5625 248.648438 20.429688 263.460938 26.097656 275.539062 C 27.417969 278.371094 28.898438 281.042969 30.507812 283.523438 C 33.632812 288.355469 37.335938 292.542969 41.488281 295.988281 C 43.519531 297.660156 45.707031 299.175781 47.960938 300.496094 L 73.984375 315.632812 C 68.925781 302.554688 66.253906 287.195312 66.222656 269.96875 C 65.996094 191.710938 121.195312 96.101562 189.304688 56.78125 C 204.695312 47.890625 219.800781 42.351562 234.035156 40.195312 L 208.015625 25.09375 C 200.058594 20.488281 190.945312 18.167969 180.996094 18.167969 M 109.632812 355.046875 C 108.152344 355.046875 106.636719 354.660156 105.285156 353.890625 L 39.234375 315.503906 C 36.175781 313.730469 33.214844 311.671875 30.445312 309.382812 C 24.90625 304.84375 20.042969 299.304688 15.953125 292.992188 C 13.890625 289.835938 12.023438 286.421875 10.382812 282.878906 C 3.683594 268.484375 0.238281 251.222656 0.171875 231.613281 C -0.0507812 153.359375 55.144531 57.746094 123.253906 18.425781 C 158.097656 -1.699219 191.300781 -4.664062 216.742188 10.117188 L 282.757812 48.472656 C 282.757812 48.472656 282.789062 48.472656 282.789062 48.503906 C 286.945312 50.917969 288.328125 56.199219 285.914062 60.355469 C 283.5 64.507812 278.183594 65.894531 274.0625 63.480469 C 254.257812 51.949219 227.207031 54.914062 197.964844 71.785156 C 134.6875 108.339844 83.355469 197.21875 83.546875 269.933594 C 83.644531 303.007812 94.433594 327.480469 113.914062 338.851562 L 113.980469 338.882812 C 118.132812 341.296875 119.519531 346.578125 117.105469 350.734375 C 115.492188 353.503906 112.59375 355.046875 109.601562 355.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6bd406ae1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 288,
    y: 0,
    height: 356
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "26fb2ecad4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 288 240 L 528 240 L 528 548 L 288 548 Z M 288 240 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae7d65ed8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 407.617188 257.316406 C 473.441406 219.316406 526.933594 249.8125 527.15625 325.394531 C 527.382812 401.007812 474.214844 493.109375 408.390625 531.109375 C 342.566406 569.109375 289.109375 538.582031 288.886719 462.96875 C 288.660156 387.351562 341.828125 295.285156 407.617188 257.316406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd4e68df26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.480469 0 L 239.519531 0 L 239.519531 308 L 0.480469 308 Z M 0.480469 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b76edc2f58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.617188 17.316406 C 185.441406 -20.683594 238.933594 9.8125 239.15625 85.394531 C 239.382812 161.007812 186.214844 253.109375 120.390625 291.109375 C 54.566406 329.109375 1.109375 298.582031 0.886719 222.96875 C 0.660156 147.351562 53.828125 55.285156 119.617188 17.316406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe49c0e569"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 240,
    y: 0,
    height: 308
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc992acec5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 280 232 L 536 232 L 536 556.480469 L 280 556.480469 Z M 280 232 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68a32839de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 411.964844 264.820312 C 348.6875 301.339844 297.355469 390.21875 297.546875 462.933594 C 297.644531 496.167969 308.527344 520.675781 328.171875 532.011719 C 347.976562 543.410156 374.933594 540.414062 404.042969 523.605469 C 467.355469 487.023438 518.6875 398.140625 518.496094 325.425781 C 518.398438 292.222656 507.515625 267.71875 487.902344 256.414062 C 468.097656 245.015625 441.140625 248.007812 411.964844 264.820312 M 354.964844 556.164062 C 342.117188 556.164062 330.167969 553.136719 319.574219 547.019531 C 294.328125 532.492188 280.382812 502.640625 280.253906 462.96875 C 280.027344 384.710938 335.226562 289.101562 403.304688 249.78125 C 438.050781 229.71875 471.15625 226.722656 496.566406 241.34375 C 521.78125 255.867188 535.757812 285.6875 535.851562 325.363281 C 536.078125 403.617188 480.847656 499.261719 412.769531 538.582031 C 392.546875 550.238281 372.902344 556.132812 354.964844 556.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74f415041a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 256 0 L 256 324.320312 L 0 324.320312 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50f3c14280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131.964844 32.820312 C 68.6875 69.339844 17.355469 158.21875 17.546875 230.933594 C 17.644531 264.167969 28.527344 288.675781 48.171875 300.011719 C 67.976562 311.410156 94.933594 308.414062 124.042969 291.605469 C 187.355469 255.023438 238.6875 166.140625 238.496094 93.425781 C 238.398438 60.222656 227.515625 35.71875 207.902344 24.414062 C 188.097656 13.015625 161.140625 16.007812 131.964844 32.820312 M 74.964844 324.164062 C 62.117188 324.164062 50.167969 321.136719 39.574219 315.019531 C 14.328125 300.492188 0.382812 270.640625 0.253906 230.96875 C 0.0273438 152.710938 55.226562 57.101562 123.304688 17.78125 C 158.050781 -2.28125 191.15625 -5.277344 216.566406 9.34375 C 241.78125 23.867188 255.757812 53.6875 255.851562 93.363281 C 256.078125 171.617188 200.847656 267.261719 132.769531 306.582031 C 112.546875 318.238281 92.902344 324.132812 74.964844 324.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e900fcf0bb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 256,
    y: 0,
    height: 325
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "283b7267ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 214 426 L 297.59375 426 L 297.59375 481.835938 L 214 481.835938 Z M 214 426 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c0ce0e146f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 288.886719 481.742188 C 287.402344 481.742188 285.890625 481.355469 284.539062 480.582031 L 218.90625 442.390625 C 214.753906 439.972656 213.367188 434.660156 215.78125 430.539062 C 218.199219 426.414062 223.511719 425 227.632812 427.414062 L 293.230469 465.574219 C 297.386719 467.992188 298.769531 473.304688 296.355469 477.425781 C 294.746094 480.195312 291.847656 481.742188 288.851562 481.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6bb93d71ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 83.59375 0 L 83.59375 55.835938 L 0 55.835938 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "12cc2339e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74.886719 55.742188 C 73.402344 55.742188 71.890625 55.355469 70.539062 54.582031 L 4.90625 16.390625 C 0.753906 13.972656 -0.632812 8.660156 1.78125 4.539062 C 4.199219 0.414062 9.511719 -1 13.632812 1.414062 L 79.230469 39.574219 C 83.386719 41.992188 84.769531 47.304688 82.355469 51.425781 C 80.746094 54.195312 77.847656 55.742188 74.851562 55.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3f1af06ac1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6927bd91ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220.1875 366 L 304 366 L 304 422 L 220.1875 422 Z M 220.1875 366 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fee1ad9c6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 295.261719 421.941406 C 293.78125 421.941406 292.265625 421.554688 290.914062 420.78125 L 225.25 382.585938 C 221.097656 380.171875 219.710938 374.859375 222.128906 370.734375 C 224.542969 366.613281 229.855469 365.199219 233.976562 367.613281 L 299.609375 405.773438 C 303.761719 408.1875 305.148438 413.503906 302.730469 417.625 C 301.121094 420.394531 298.222656 421.941406 295.230469 421.941406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3a586422f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.1875 0 L 84 0 L 84 56 L 0.1875 56 Z M 0.1875 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d1e48f2cf7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.261719 55.941406 C 73.78125 55.941406 72.265625 55.554688 70.914062 54.78125 L 5.25 16.585938 C 1.097656 14.171875 -0.289062 8.859375 2.128906 4.734375 C 4.542969 0.613281 9.855469 -0.800781 13.976562 1.613281 L 79.609375 39.773438 C 83.761719 42.1875 85.148438 47.503906 82.730469 51.625 C 81.121094 54.394531 78.222656 55.941406 75.230469 55.941406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac9092bec1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "302637429c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 246 306.292969 L 330 306.292969 L 330 362.964844 L 246 362.964844 Z M 246 306.292969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c3384e103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 320.703125 362.171875 C 319.21875 362.171875 317.707031 361.785156 316.355469 361.011719 L 250.722656 322.816406 C 246.570312 320.402344 245.183594 315.089844 247.601562 310.964844 C 250.015625 306.84375 255.328125 305.429688 259.449219 307.84375 L 325.082031 346.003906 C 329.234375 348.417969 330.621094 353.734375 328.207031 357.855469 C 326.59375 360.625 323.695312 362.171875 320.703125 362.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50e51edf42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.292969 L 84 0.292969 L 84 56.398438 L 0 56.398438 Z M 0 0.292969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3e2239fa3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74.703125 56.171875 C 73.21875 56.171875 71.707031 55.785156 70.355469 55.011719 L 4.722656 16.816406 C 0.570312 14.402344 -0.816406 9.089844 1.601562 4.964844 C 4.015625 0.84375 9.328125 -0.570312 13.449219 1.84375 L 79.082031 40.003906 C 83.234375 42.417969 84.621094 47.734375 82.207031 51.855469 C 80.59375 54.625 77.695312 56.171875 74.703125 56.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae197be47a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "389289b7d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 283 250 L 366.707031 250 L 366.707031 307 L 283 307 Z M 283 250 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a78226822d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 357.605469 306.425781 C 356.125 306.425781 354.613281 306.039062 353.257812 305.265625 L 287.597656 267.074219 C 283.441406 264.660156 282.058594 259.34375 284.472656 255.222656 C 286.886719 251.101562 292.203125 249.683594 296.324219 252.097656 L 361.953125 290.261719 C 366.109375 292.675781 367.492188 297.988281 365.078125 302.109375 C 363.46875 304.878906 360.570312 306.425781 357.574219 306.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1a1b99606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 83.707031 0 L 83.707031 56.480469 L 0 56.480469 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "57a185ffe0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74.605469 56.425781 C 73.125 56.425781 71.613281 56.039062 70.257812 55.265625 L 4.597656 17.074219 C 0.441406 14.660156 -0.941406 9.34375 1.472656 5.222656 C 3.886719 1.101562 9.203125 -0.316406 13.324219 2.097656 L 78.953125 40.261719 C 83.109375 42.675781 84.492188 47.988281 82.078125 52.109375 C 80.46875 54.878906 77.570312 56.425781 74.574219 56.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "012f601645"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "928851aac4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 338 206.769531 L 421.996094 206.769531 L 421.996094 263 L 338 263 Z M 338 206.769531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9800c1b5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.191406 262.402344 C 411.707031 262.402344 410.195312 262.019531 408.84375 261.246094 L 343.210938 223.050781 C 339.058594 220.636719 337.671875 215.324219 340.089844 211.199219 C 342.503906 207.078125 347.816406 205.660156 351.9375 208.078125 L 417.570312 246.238281 C 421.722656 248.652344 423.109375 253.964844 420.695312 258.089844 C 419.082031 260.859375 416.183594 262.402344 413.191406 262.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5189db6299"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.769531 L 83.996094 0.769531 L 83.996094 56.558594 L 0 56.558594 Z M 0 0.769531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba57071af4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.191406 56.402344 C 73.707031 56.402344 72.195312 56.019531 70.84375 55.246094 L 5.210938 17.050781 C 1.058594 14.636719 -0.328125 9.324219 2.089844 5.199219 C 4.503906 1.078125 9.816406 -0.339844 13.9375 2.078125 L 79.570312 40.238281 C 83.722656 42.652344 85.109375 47.964844 82.695312 52.089844 C 81.082031 54.859375 78.183594 56.402344 75.191406 56.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "156c07dcc2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cfa2290524"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 370 318 L 456 318 L 456 461 L 370 461 Z M 370 318 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38f1715fdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.285156 378.691406 C 399.503906 386.195312 385.753906 393.730469 370.648438 401.972656 C 375.480469 390.765625 378.667969 380.71875 390.324219 376.308594 C 397.925781 373.410156 404.785156 368.578125 412 364.617188 C 411.871094 363.78125 411.742188 362.941406 411.578125 362.105469 C 407.585938 362.683594 403.207031 362.460938 399.664062 364.039062 C 392.128906 367.386719 385.011719 371.671875 377.734375 375.566406 C 375.800781 376.597656 373.804688 377.59375 370.585938 379.269531 C 375.027344 368.835938 378.054688 360.042969 388.425781 354.925781 C 409.324219 344.554688 429.484375 332.734375 449.964844 321.496094 C 451.707031 320.5625 453.476562 319.695312 455.796875 318.535156 C 452.253906 331.578125 445.8125 341.171875 432.320312 344.910156 C 433.414062 347.613281 434.21875 349.578125 435.152344 351.898438 C 442.238281 348.066406 448.839844 344.523438 455.472656 340.949219 C 451.800781 350.160156 450.320312 360.722656 439.179688 364.585938 C 437.503906 365.164062 435.570312 367.128906 435.183594 368.804688 C 430.484375 389.316406 416.667969 402.714844 400.4375 414.273438 C 399.695312 414.789062 398.988281 415.402344 398.3125 416.015625 C 398.183594 416.109375 398.214844 416.402344 398.023438 417.335938 C 412.609375 427.027344 427.457031 436.914062 443.269531 447.414062 C 434.992188 451.984375 427.585938 456.203125 419.984375 460.070312 C 418.890625 460.648438 416.539062 459.8125 415.285156 458.910156 C 402.722656 449.988281 390.230469 441.003906 377.832031 431.890625 C 371.582031 427.316406 372.710938 415.144531 379.375 411.183594 C 386.847656 406.707031 394.707031 402.617188 401.339844 397.109375 C 406.78125 392.601562 410.679688 386.257812 415.285156 380.71875 C 414.605469 380.042969 413.964844 379.398438 413.285156 378.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7807bd0b9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.558594 0.480469 L 86 0.480469 L 86 142.800781 L 0.558594 142.800781 Z M 0.558594 0.480469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f46dade78f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.285156 60.691406 C 29.503906 68.195312 15.753906 75.730469 0.648438 83.972656 C 5.480469 72.765625 8.667969 62.71875 20.324219 58.308594 C 27.925781 55.410156 34.785156 50.578125 42 46.617188 C 41.871094 45.78125 41.742188 44.941406 41.578125 44.105469 C 37.585938 44.683594 33.207031 44.460938 29.664062 46.039062 C 22.128906 49.386719 15.011719 53.671875 7.734375 57.566406 C 5.800781 58.597656 3.804688 59.59375 0.585938 61.269531 C 5.027344 50.835938 8.054688 42.042969 18.425781 36.925781 C 39.324219 26.554688 59.484375 14.734375 79.964844 3.496094 C 81.707031 2.5625 83.476562 1.695312 85.796875 0.535156 C 82.253906 13.578125 75.8125 23.171875 62.320312 26.910156 C 63.414062 29.613281 64.21875 31.578125 65.152344 33.898438 C 72.238281 30.066406 78.839844 26.523438 85.472656 22.949219 C 81.800781 32.160156 80.320312 42.722656 69.179688 46.585938 C 67.503906 47.164062 65.570312 49.128906 65.183594 50.804688 C 60.484375 71.316406 46.667969 84.714844 30.4375 96.273438 C 29.695312 96.789062 28.988281 97.402344 28.3125 98.015625 C 28.183594 98.109375 28.214844 98.402344 28.023438 99.335938 C 42.609375 109.027344 57.457031 118.914062 73.269531 129.414062 C 64.992188 133.984375 57.585938 138.203125 49.984375 142.070312 C 48.890625 142.648438 46.539062 141.8125 45.285156 140.910156 C 32.722656 131.988281 20.230469 123.003906 7.832031 113.890625 C 1.582031 109.316406 2.710938 97.144531 9.375 93.183594 C 16.847656 88.707031 24.707031 84.617188 31.339844 79.109375 C 36.78125 74.601562 40.679688 68.257812 45.285156 62.71875 C 44.605469 62.042969 43.964844 61.398438 43.285156 60.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2cbade3d95"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 86,
    y: 0,
    height: 143
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c46f8c7c0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8c60d85af)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 222, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aca990eefb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5c5c4e7bda)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8263fcea74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -387,
    width: 1080,
    fill: "#ffffff",
    height: 1079.999992,
    y: -366.999999,
    fillOpacity: 1
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#23dbcee4f7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84ee02bbda)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 214, 193)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6bd406ae1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72ee2fa542)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fae01e9be3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -379,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -357.999999,
    fillOpacity: 1
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#26fb2ecad4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae7d65ed8c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 288, 240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe49c0e569)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd4e68df26)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b76edc2f58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -453,
    width: 1080,
    fill: "#ced4ff",
    height: 1079.999992,
    y: -404.999999,
    fillOpacity: 1
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fc992acec5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68a32839de)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 280, 232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e900fcf0bb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74f415041a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50f3c14280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -445,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -396.999999,
    fillOpacity: 1
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#283b7267ff)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c0ce0e146f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 214, 426)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3f1af06ac1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6bb93d71ab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#12cc2339e5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -379,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -590.999999,
    fillOpacity: 1
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6927bd91ca)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fee1ad9c6a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 220, 366)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac9092bec1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a586422f0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1e48f2cf7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -385,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -530.999999,
    fillOpacity: 1
  })))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#302637429c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c3384e103)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 246, 306)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae197be47a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50e51edf42)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3e2239fa3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -411,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -470.999999,
    fillOpacity: 1
  })))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#389289b7d0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a78226822d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 283, 250)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#012f601645)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1a1b99606)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#57a185ffe0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -448,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -414.999999,
    fillOpacity: 1
  })))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#928851aac4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9800c1b5d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 338, 206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#156c07dcc2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5189db6299)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba57071af4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -503,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -370.999999,
    fillOpacity: 1
  })))))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cfa2290524)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38f1715fdc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 370, 318)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2cbade3d95)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7807bd0b9e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f46dade78f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -535,
    width: 1080,
    fill: "#2818ff",
    height: 1079.999992,
    y: -482.999999,
    fillOpacity: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycBank);
export default __webpack_public_path__ + "static/media/kyc-bank.76adc2ceb7c5847ba4b196fa4a39054b.svg";
export { ForwardRef as ReactComponent };